import React, {
  createContext,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { API_URL, doApiGet } from '../services/apiService'
import {
  isTokenExpiredHelper,
  userDisconnectionHelper,
} from '../services/authService'
import { LoadingSpinner } from '../services/LoadingSpinner'
import { fetchFamilyData, handlePathChangeHelper } from '../utils/familyData'
import {
  getAncestorPathHelper,
  getPersonRouteHelper,
  getRelevantIdHelper,
  processPersonHelper,
} from '../utils/familyUtils'

export const FamilyContext = createContext(null)
export const FamilyHeadProvider = ({ children }) => {
  const { i18n } = useTranslation()
  const location = useLocation()
  const [headerStyle, setHeaderStyle] = useState(null);
  const [familyHeadsBazach, setFamilyHeadsBazach] = useState([])
  const [familyHeadsHumenir, setFamilyHeadsHumenir] = useState([])
  const [currentFamilyHead, setCurrentFamilyHead] = useState({
    _id: null,
    name: null,
    mongoId: null,
    gedId: null,
    nickname: null,
    isMain: false,
  })
  const [isMainSite, setIsMainSite] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [pathPrefix, setPathPrefix] = useState(`/`)
  const [isInitialized, setIsInitialized] = useState(false)
  const [currentAnnouncement, setCurrentAnnouncement] = useState('')
  const huminerMain = useMemo(() => {
    return familyHeadsHumenir.find((h) => h.nickname === 'hshmuel')
  }, [familyHeadsHumenir])
  const bazachMain = useMemo(() => {
    return familyHeadsBazach.find((h) => h.nickname === 'bazach')
  }, [familyHeadsBazach])
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const userDisconnection = async () =>
    await userDisconnectionHelper(setIsAuthenticated)
  const isTokenExpired = async () =>
    await isTokenExpiredHelper(setIsAuthenticated)
  const getAncestorPath = (gedId) =>
    getAncestorPathHelper(
      i18n.language,
      gedId,
      isMainSite,
      familyHeadsBazach,
      familyHeadsHumenir,
      huminerMain,
      bazachMain,
    )
  const getRelevantId = (ids) =>
    getRelevantIdHelper(ids, isMainSite, huminerMain, bazachMain)
  const processPerson = (person) =>
    processPersonHelper(
      i18n.language,
      person,
      currentFamilyHead,
      pathPrefix,
      isMainSite,
      huminerMain,
      bazachMain,
      familyHeadsBazach,
      familyHeadsHumenir,
    )
  const getPersonRoute = (person) =>
    getPersonRouteHelper(
      i18n.language,
      person,
      currentFamilyHead,
      isMainSite,
      bazachMain,
      huminerMain,
      pathPrefix,
      familyHeadsBazach,
      familyHeadsHumenir,
    )
  useLayoutEffect(() => {
    isTokenExpired().then(() => console.log('isTokenExpired'))
  }, [isAuthenticated])


  useLayoutEffect(() => {
    const fetchData = async () => {
      try {
        await fetchFamilyData(
          location,
          isMainSite,
          currentFamilyHead,
          setCurrentFamilyHead,
          setPathPrefix,
          setFamilyHeadsBazach,
          setFamilyHeadsHumenir,
          setLoading,
          setIsInitialized,
          setError,
          setIsMainSite,
          i18n,
            pathPrefix,
        )
        await doApiGet(`${API_URL}/user-count/content`).then((data) => {
          setCurrentAnnouncement(data.managementContent)
        })
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData().then((r) => console.log('fetchData'))
  }, [])

  // אפקט לשינויים בנתיב ה-URL
  useLayoutEffect(() => {
    if (!isInitialized) return
    handlePathChangeHelper(
      location,
      isMainSite,
      currentFamilyHead,
      setCurrentFamilyHead,
      setPathPrefix,
      setIsMainSite,
      familyHeadsBazach,
      familyHeadsHumenir,
      i18n,
        pathPrefix,
    )
  }, [location.pathname])

  const value = {
    pathPrefix,
    setPathPrefix,
    currentFamilyHead,
    isMainSite,
    loading,
    error,
    familyHeadsBazach,
    familyHeadsHumenir,
    getAncestorPath,
    getPersonRoute,
    bazachMain,
    huminerMain,
    getRelevantId,
    processPerson,
    isAuthenticated,
    setIsAuthenticated,
    userDisconnection,
    setCurrentAnnouncement,
    currentAnnouncement,
    headerStyle,
    setHeaderStyle
  }
  if (!isInitialized) {
    return <LoadingSpinner />
  }

  // If there's an error, you might want to show an error message
  if (error) {
    return <div className="text-red-500 text-center p-4">{error}</div>
  }

  return (
    <FamilyContext.Provider value={value}>{children}</FamilyContext.Provider>
  )
}
